import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import ModuleContext from 'CMFW/context/ModuleContext';
import KeyContext from 'CMFW/context/KeyContext';
import { BaseModel } from '../../../models/BaseModel';
import { createKeyPath } from 'CMFW/context/helper/keyContext';
import { useCurrentItemValue } from 'hooks/useCurrentItemValue';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  keyName: string;
}

const ActiveInflectCellRenderer: React.FC<IProps> = ({ keyName }) => {
  const module = useContext(ModuleContext) as BaseModel<any, any>;
  const parentKey = useContext(KeyContext);
  const aggregatedKeyName = createKeyPath(parentKey, keyName);

  const moduleItemValue: boolean = module.getItemValue.bind(module)(aggregatedKeyName) ?? false;
  const moduleItemValueUpdated: boolean = module.getItemUpdatedValue(aggregatedKeyName, false) ?? false;

  const [currentValue, setCurrentValue] = useCurrentItemValue(moduleItemValue, false);

  useEffect(() => {
    setCurrentValue(moduleItemValueUpdated);
  }, [moduleItemValueUpdated, setCurrentValue]);

  const handleClick = () => {
    const newValue = !currentValue;
    setCurrentValue(newValue);
    module.updateItemValue.bind(module)(aggregatedKeyName, newValue);
  };

  return (
    <CellContainer onClick={handleClick} $active={currentValue}>
      <IconButton $active={currentValue}>
        <FontAwesomeIcon icon={currentValue ? faCheck : faTimes} size="sm" />
      </IconButton>
    </CellContainer>
  );
};

const CellContainer = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  user-select: none;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: #f3f4f6;
  }
`;

const IconButton = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-color: ${(props) => (props.$active ? '#10B981' : '#F3F4F6')};
  color: ${(props) => (props.$active ? '#FFFFFF' : '#6B7280')};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$active ? '#059669' : '#E5E7EB')};
    transform: scale(1.05);
  }

  svg {
    font-size: 14px;
  }
`;

export default ActiveInflectCellRenderer;
